import React from "react";
import { Container, Title, Description, Button } from "../general/index";

const Intro = () => {
  return (
    <Container className="intro-page flex flex-col justify-center py-10">
      <Title margin="2">Never stress about leaving work undone again</Title>
      <Description>
        {/* A simple intuitive newtab dashboard that puts your tasks, goals, and
        screen time into focus */}
        Fructify is a personal workspace on the new tab page designed to help
        people optimize their digital workflow.
      </Description>
      <div className="intro__btn-container mt-6 flex justify-center items items-center">
        <Button
          as="a"
          href="https://chrome.google.com/webstore/detail/fructify/gpppkkkidmlbdenkajgcpfkjocmdbock"
          target="_blank"
        >
          Add To Chrome
        </Button>
        <Button as="a" type="secondary" href="#features">
          Learn More
        </Button>
      </div>
    </Container>
  );
};

export default Intro;
